<template>
  <div
    class="new-checkbox"
    :class="[
      { isChecked: checked || (checkAllMode == 1 && checkAll) },
      { disabled: isDisabled },
      { [sizeClass]: true }
    ]"
    @click.stop="toggle"
  >
    <input class="new-checkbox__input" type="checkbox" />
    <div class="new-checkbox__marker">
      <div
        class="new-checkbox__icon"
        v-show="checked && !checkAll && !viewMinus"
      >
        <icon name="new_vektor"></icon>
      </div>
      <div
        class="new-checkbox__icon"
        v-show="checkAllMode == 1 && checkAll && !viewMinus"
      >
        <icon name="new_vektor-minus"></icon>
      </div>
      <div class="new-checkbox__icon" v-show="viewMinus">
        <icon name="new_vektor-minus"></icon>
      </div>
    </div>
    <div class="new-checkbox__label" v-if="label">{{ label }}</div>
  </div>
</template>

<script>
export default {
  props: {
    checkedProps: {
      type: Boolean,
      require: false
    },
    viewMinus: {
      type: Boolean,
      require: false
    },
    subParent: {
      type: Boolean,
      require: false
    },
    childrens: {
      type: Array,
      require: false
    },
    checkAllClick: {
      type: Boolean,
      require: false
    },
    checkAll: {
      type: Boolean,
      require: false
    },
    checkedLessons: {
      type: Array,
      require: false
    },
    checkItem: {
      type: Object
    },
    disabled: {
      type: Boolean,
      default: false
    },
    checkAllMode: {
      type: Number,
      require: false
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md', 'lg', 'xl'].includes(value)
    },
    label: {
      type: String,
      default: ''
    },
    is_all: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      checked: this.checkedProps ? this.checkedProps : false,
      allCheck: false
    };
  },
  computed: {
    isChecked() {
      return this.checked && !this.isDisabled;
    },
    isDisabled() {
      return this.disabled;
    },
    sizeClass() {
      const sizeClasses = {
        sm: 'new-checkbox--sm',
        md: 'new-checkbox--md',
        lg: 'new-checkbox--lg',
        xl: 'new-checkbox--xl'
      };
      return sizeClasses[this.size];
    }
  },
  watch: {
    checkAllMode(val) {
      if (val === 0) {
        this.checked = false;
      }
    },
    checkAllClick(val) {
      if (val) {
        this.checked = true;
        this.$emit('checked', this.checkItem, this.checked, val);
      }
      if (!val) {
        this.checked = false;
        this.$emit('checked', this.checkItem, this.checked, val);
      }
    }
  },
  methods: {
    toggle() {
      console.log('checkAllFunClick');
      if (this.is_all) {
        this.$emit('checkAllFunClick');
      }
      if (this.checked) {
        this.$emit('uncheck', this.checkItem);
      }
      if (!this.checked) {
        this.$emit('check', this.checkItem);
      }
      if (!this.isDisabled && !this.checkAll && !this.subParent) {
        this.checked = !this.checked;
        this.$emit('checked', this.checkItem, this.checked);
      }
      if (this.checkAll && !this.subParent) {
        this.allCheck = !this.allCheck;
        this.$emit('checkAllFun');
      }
      if (this.subParent === true) {
        this.checked = !this.checked;
        this.$emit('checkSubParent', this.childrens, this.checked);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.new-checkbox {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  gap: 8px;
  &__input {
    display: none;
  }
  &__marker {
    border: 1px solid #c7cfdd;
    border-radius: 8px;
    width: 24px;
    height: 24px;
    transition: 0.3s;
  }
  &__icon {
    transition: 0.3s;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 16px;
      height: 16px;
    }
  }
  &__label {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    text-align: right;
    color: #38455d;
  }
  &:hover {
    .new-checkbox {
      &__marker {
        border: 1px solid #409fff;
        background: #eef7ff;
      }
    }
  }
  &.isChecked {
    .new-checkbox {
      &__marker {
        border: 1px solid #409fff;
        background: #409fff;
      }
    }
  }
}
</style>
